import { useEffect, useState } from 'react';
import FadeIn from '../../../components/Animation/FadeIn';
import Paragraph from '../../../components/Typography/Paragraph';
import axiosInstance from '../../../config/axios';
import { api } from '../../../config/api';
import { ArrowRight, Loader, Plus } from "react-feather";
import { Link } from 'react-router-dom';
import { RoutePaths } from '../../../config/routes';
var DashboardFavorites = function () {
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    var _b = useState([]), favoritesLists = _b[0], setFavoritesLists = _b[1];
    var loadFavoritesList = function () {
        setLoading(true);
        axiosInstance.get(api.favorites.all(true)).then(function (_a) {
            var data = _a.data;
            setFavoritesLists(data);
            setLoading(false);
        });
    };
    useEffect(function () {
        loadFavoritesList();
    }, []);
    return (<FadeIn>
      <div className="my-10 grid gap-6 lg:my-20 lg:grid-cols-12">
        <div className="lg:col-span-10 lg:col-start-2 xl:col-span-8 xl:col-start-3">
          {loading && (<div className="flex items-center justify-center p-24">
              <Loader size={30} className="animate-spin-loader text-brand-01"/>
            </div>)}

          {(favoritesLists === null || favoritesLists === void 0 ? void 0 : favoritesLists.length)
            ?
                <>
              <Paragraph className="mb-8 font-medium">
                Mes Listes ({favoritesLists === null || favoritesLists === void 0 ? void 0 : favoritesLists.length})
              </Paragraph>
              {favoritesLists.map(function (favoritesList, i) {
                        var _a, _b, _c, _d, _e;
                        return (<Link to={RoutePaths.DASHBOARD_FAVORITES_LIST.replace(':listId', favoritesList.id.toString())} key={favoritesList.id} className={"p-4 border border-gray-200 flex justify-between items-center rounded-lg mb-3 last:mb-0"}>
                      <div className={"flex flex-col"}>
                        <div className={"font-medium text-lg"}>{favoritesList.name}</div>
                        <div className={"flex items-center mt-2"}>
                          {((_a = favoritesList === null || favoritesList === void 0 ? void 0 : favoritesList.detailedProfiles) === null || _a === void 0 ? void 0 : _a.length) ?
                                <ul className={"flex list-none mr-2"}>
                              {(_b = favoritesList.detailedProfiles) === null || _b === void 0 ? void 0 : _b.slice(0, 2).map(function (profile) {
                                        return <li key={profile.id} className="-ml-1 rounded-full w-8 h-8 overflow-hidden">
                                  <img width="32" height="32" src={profile.avatar_small} alt={profile.full_name}/>
                                </li>;
                                    })}
                              {((_c = favoritesList === null || favoritesList === void 0 ? void 0 : favoritesList.detailedProfiles) === null || _c === void 0 ? void 0 : _c.length) > 2 &&
                                        <li className="-ml-1 w-8 h-8 rounded-full overflow-hidden">
                                  <div className="w-8 h-8 bg-brand-02 flex items-center justify-center">
                                    <Plus size={12} className="text-white"/>
                                  </div>
                                </li>}
                            </ul>
                                : null}
                          <div className="text-xs text-gray-600">{(_d = favoritesList === null || favoritesList === void 0 ? void 0 : favoritesList.detailedProfiles) === null || _d === void 0 ? void 0 : _d.length} profil{((_e = favoritesList.profiles) === null || _e === void 0 ? void 0 : _e.length) > 1 && 's'}</div>
                        </div>
                      </div>

                      <ArrowRight size={18}/>
                    </Link>);
                    })}
            </>
            : !loading && <Paragraph className="text-center text-gray-400 p-4">Aucune liste disponible.</Paragraph>}
        </div>
      </div>
    </FadeIn>);
};
export default DashboardFavorites;
